<template>
  <v-app>
    <let-it-snow v-bind="snowConf" :show="true"></let-it-snow>
    <router-view></router-view>
  </v-app>
</template>

<script>
import { Decrypt, Encrypt } from "./lib/encryption";

export default {
  name: "App",
  data() {
    return {
      snowConf: {
        windPower: 1,
        speed: 3,
        count: 12,
        size: 10,
        opacity: 1,
        images: [
          "https://raw.githubusercontent.com/bob-chen/let_it_snow/master/demo/snow.png",
          "https://raw.githubusercontent.com/bob-chen/let_it_snow/master/demo/sock.png",
          "https://raw.githubusercontent.com/bob-chen/let_it_snow/master/demo/tree.png",
        ],
      },
      show: true,
      encryptsecret: "kasjffssvgsfjjsafs",
    };
  },
  components: {},
  beforeCreate() {
    if (!JSON.pars(Decrypt(localStorage.dark))) {
      localStorage.isdark = Encrypt(JSON.stringify(true));
    }
    let dark = JSON.pars(Decrypt(localStorage.dark));
    this.$vuetify.theme.dark = dark;

    this.$vuetify.theme.dark = JSON.parse(Decrypt(localStorage.isdark));
  },
};
</script>
